import { Component, OnInit, Input } from '@angular/core';
import { ClipboardService } from 'ngx-clipboard';
import { PackageDataService } from '../../data-services/package.service';
import { SelectItem } from 'primeng/api';
import { MessageService } from 'primeng/api';
import { RequisitionDataService } from '../../data-services/requisition.service';
import { UserDataService } from '../../data-services/user.service';
import { AccordionModule } from 'primeng/accordion';
import { FormsModule } from '@angular/forms';
import { Toast } from 'primeng/toast';
import { CommonModule } from '@angular/common';
import { SelectModule } from 'primeng/select';
import { ReceivingSampleComponent } from './receiving.sample';
import { HasClaimDirective } from '../../security/has-claim.directive';

@Component({
  selector: 'app-receiving-package',
  templateUrl: './receiving.package.html',
  providers: [MessageService],
  imports: [AccordionModule, FormsModule, Toast, CommonModule, SelectModule, ReceivingSampleComponent, HasClaimDirective]
})
export class ReceivingPackageComponent implements OnInit {

  constructor(private packageDataService: PackageDataService,
    private messageService: MessageService,
    private requisitionService: RequisitionDataService,
    private userService: UserDataService,
    private _clipboardService: ClipboardService) {
  }

  @Input() packageId: any = 28;
  @Input() searchTerm: string;
  loading: boolean = false;
  processingExceptions: boolean = false;
  package: any = {};
  requisitions: any[];
  resolveUsers: SelectItem[];
  reqCount: number = 0;
  reqCountRejected: number = 0;
  reqCountException: number = 0;

  ngOnInit() {
    this.loading = true;
    this.loadPackage();

    this.requisitionService.getListForPackage(this.packageId).subscribe((data: any) => {
      console.log("samples", data);
      this.requisitions = data;
      this.countRequisitions();
    });

    this.userService.getDistinctAssignableResolveUsers().subscribe((data: any) => {
      console.log("Resolve Users", data);
      this.resolveUsers = data;
      this.resolveUsers.unshift({ label: 'Select', value: null });
    });
  }

  resolveTeamAssignedToOnChange() {
    this.packageDataService.updatePackageResolveTeamAssignedTo(this.package).subscribe((data: any) => {
      console.log("package", data);
      this.package = data;
      this.loading = false;
    });
  }

  loadPackage() {
    this.packageDataService.getPackage(this.packageId).subscribe((data: any) => {
      console.log("package", data);
      this.package = data;
      this.loading = false;
    });
  }

  reopenPackage() {
    this.packageDataService.reopenPackage(this.packageId).subscribe((data: any) => {
      this.package.CompletedDate = null;
      this.loading = false;
    });
  }

  countRequisitions() {
    this.reqCount = 0;
    this.reqCountException = 0;
    this.reqCountRejected = 0;

    if (this.requisitions != null) {
      for (var i = 0; i < this.requisitions.length; i++) {
        this.reqCount = this.reqCount + 1;
        if (this.requisitions[i].IsRejected) {
          this.reqCountRejected = this.reqCountRejected + 1;
        } else if (this.requisitions[i].HasExceptions) {
          this.reqCountException = this.reqCountException + 1;
        }
      }
    }
  }

  public attemptToResolveRequisitionExceptions() {
    this.processingExceptions = true;
    this.requisitionService.attemptToResolveRequisitionExceptionsPackage(this.packageId).subscribe((data: any) => {
      this.loadPackage();
      this.processingExceptions = false;
    },
      (err) => {
        this.messageService.add({ severity: 'error', summary: 'Attempt to Resolve Requisition Exceptions', detail: 'Error: ' + err.status });
        this.loadPackage();
        this.processingExceptions = false;
      });
  }
  updateSample(req) {
    var oReq = this.requisitions.filter(x => x.Id == req.Id);
    if (oReq.length > 0) {
      oReq[0].StatusLevel = req.StatusLevel;
      this.countRequisitions();
      oReq[0].FirstName = req.FirstName;
      oReq[0].LastName = req.LastName;
    }
  }

  public copyToClipBoard(type) {
    if (!this.requisitions) {
      this.messageService.add({ severity: 'error', summary: 'Clipboard copy - nothing to copy', detail: 'There are no samples in the package ' });
    }
    var copyText = "";
    var getClipboardText = function(val) {
      var dob = val.BirthDate ? new Date(val.BirthDate).toLocaleDateString() : "";
      return val.Accession +
        ((val.FirstName || val.LastName) ? " - " : "") +
        [val.FirstName, val.LastName] +
        (val.BirthDate ? " - " : "") +
        [dob];
    };

    if (type == "A") {
      this.requisitions.forEach(function (val) {

        copyText += getClipboardText(val) + " \r\n";
      });
    } else if (type == "E") {
      this.requisitions.filter(x => x.IsRejected == false && x.HasExceptions).forEach(function (val) {
        copyText += getClipboardText(val) + " \r\n";        
      });
    } else if (type == "R") {
      this.requisitions.filter(x => x.IsRejected).forEach(function (val) {
        copyText += getClipboardText(val) + " \r\n";    
      });
    }

    this._clipboardService.copy(copyText);
    this.messageService.add({ severity: 'success', summary: 'Package Exceptions', detail: 'copied to clipboard' });
  }

}
